import React, { useState, useEffect } from "react";
import SockJsClient from "react-stomp";
import config from "../../../config/config";
import {useDispatch} from "react-redux";
import AlertsAction from "../../../store/alerts/alertsAction";

const MainWebSocket = () => {
  const dispatch = useDispatch();

  //state
  const [initSocket, setInitSocket] = useState(false);

  //effects
  useEffect(() => {
    setInitSocket(true);
  }, []);

  //handlers
  const handleWSMessage = msg => {
    console.log('handleWSMessage', msg);
    dispatch(AlertsAction.incrementUnreadAlerts());
  }

  return (
    <>
      {initSocket && (
        <SockJsClient
          url={config.api_websocket}
          topics={['/topic/notifications']}
          onMessage={ msg => { handleWSMessage(msg) } }
          onConnect={() => {console.log('webint socket connected!')}}
          onDisconnect={() => {console.log('webint socket DISconnected!')}}
        />
      )}
    </>
  );
};

export default MainWebSocket;